"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("../Button");
var ErrorText_1 = require("../ErrorText");
var TextInput_1 = require("../TextInput");
var AddressInputFields = /** @class */ (function (_super) {
    __extends(AddressInputFields, _super);
    function AddressInputFields() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filterErrors = function (errors) {
            var fields = ['house_name', 'house_number', 'flat', 'street', 'town', 'county', 'postcode'];
            return Object.keys(errors)
                .filter(function (key) { return fields.indexOf(key) !== -1; })
                .reduce(function (obj, key) {
                obj[key] = errors[key];
                return obj;
            }, {});
        };
        return _this;
    }
    AddressInputFields.prototype.render = function () {
        var _a = this.props, name = _a.name, address = _a.address, handleChange = _a.handleChange, errors = _a.errors, clearAddress = _a.clearAddress, handleDone = _a.handleDone, validateField = _a.validateField;
        return (React.createElement("div", { className: 'manual-wrapper' },
            React.createElement(TextInput_1.default, { name: name + ".house_name", label: 'House name', value: address.house_name || '', handleChange: handleChange, errors: errors.house_name || errors[name + ".house_name"] || '', validateStandard: validateField }),
            React.createElement(TextInput_1.default, { name: name + ".house_number", label: 'House number', value: address.house_number || '', handleChange: handleChange, errors: errors.house_number || errors[name + ".house_number"] || '', validateStandard: validateField }),
            React.createElement(TextInput_1.default, { name: name + ".flat", label: 'Flat', value: address.flat || '', handleChange: handleChange, errors: errors.flat || errors[name + ".flat"] || '', validateStandard: validateField }),
            React.createElement(TextInput_1.default, { name: name + ".street", label: 'Street name', value: address.street || '', handleChange: handleChange, errors: errors.street || errors[name + ".street"] || '', validateStandard: validateField }),
            React.createElement(TextInput_1.default, { name: name + ".town", label: 'Town/City', value: address.town || '', handleChange: handleChange, errors: errors.town || errors[name + ".town"] || '', validateStandard: validateField }),
            React.createElement(TextInput_1.default, { name: name + ".county", label: 'County', value: address.county || '', handleChange: handleChange, errors: errors.county || errors[name + ".county"] || '', validateStandard: validateField }),
            React.createElement(TextInput_1.default, { name: name + ".postcode", label: 'Postcode', value: address.postcode || '', handleChange: handleChange, errors: errors.postcode || errors[name + ".postcode"] || '', validateStandard: validateField }),
            React.createElement(ErrorText_1.default, { errors: this.filterErrors(errors), displayedText: 'The address that you have entered is not valid' }),
            React.createElement("div", { className: 'form-group buttons' },
                React.createElement(Button_1.default, { className: 'unstyled search-again', handleClick: clearAddress }, "Search again"),
                React.createElement(Button_1.default, { className: 'button light done-button secondary', handleClick: handleDone }, "Done"))));
    };
    return AddressInputFields;
}(React.Component));
exports.default = AddressInputFields;
